import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import qs from 'qs';

import { iconColors, iconSizes, iconTypes, SecondaryModal } from '../../components/pbg-ui-library';
import { formatMessage } from '../../../lib/intl';
import TopNavBar from '../../containers/top-nav-bar.container';
import Footer from '../../containers/footer.container';

import { i18n } from './payment-successful.i18n';

import '../../css/payment-successful.css';

class PaymentSuccessful extends React.PureComponent {
  formatMessage = formatMessage(this.props.intl ? this.props.intl : {});
  query = qs.parse(this.props.location.search.substring(1));

  get alreadyPaid() {
    return this.query.alreadyPaid && this.query.alreadyPaid === 'true';
  }

  renderAlreadyPaid() {
    const { purchase: { merchant } } = this.props;
    return (
      <React.Fragment>
        <TopNavBar />
        <div className="payment-successful-page">
          <SecondaryModal
            iconType="credit-cards-success"
            title={this.formatMessage(i18n.alreadySubmitted)}
          >
            <p className="pbg-consumer-desktop pbg-desktop-paragraph">
              {this.formatMessage(i18n.contactSupport, { merchantName: merchant.displayName })}
              <br />
              {this.formatMessage(i18n.instructions)}
            </p>
          </SecondaryModal>
          <Footer />
        </div>
      </React.Fragment>
    );
  }

  renderConfirmation() {
    return (
      <React.Fragment>
        <TopNavBar />
        <div className="payment-successful-page">
          <SecondaryModal
            iconType={iconTypes.CREDIT_CARDS_SUCCESS}
            iconSize={iconSizes.BIG}
            iconColor={iconColors.GREEN}
            title={this.formatMessage(i18n.title)}
          >
            <p className="pbg-consumer-desktop pbg-desktop-paragraph">
              {this.formatMessage(i18n.instructions)}
            </p>
          </SecondaryModal>
          <Footer />
        </div>
      </React.Fragment>
    );
  }

  render() {
    if (this.alreadyPaid) return this.renderAlreadyPaid();
    return this.renderConfirmation();
  }
}
const mapStateToProps = (state) => {
  return {
    purchase: state.purchases.byId[state.purchases.current],
  };
}

export default connect(mapStateToProps)(injectIntl(PaymentSuccessful));



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/payment-successful.js